import { css } from "styled-components";
import { mediaQueryMixin } from "../mediaQueryMixin";
import { inlineMediaQueryMixin } from "../inlineMediaQueryMixin";
import { spacingMixin } from "../spacingMixin";
import { spaceMixin } from "../spaceMixin";
var ATTRIBUTES = ["display", "flexFlow", "flexDirection", "flexWrap", "justifyContent", "alignItems", "alignContent", "flex", "order", "flexGrow", "flexShrink", "flexBasis", "alignSelf"];

var flexCSS = function flexCSS(props) {
  var styles = [];

  var _loop = function _loop(i) {
    var attr = ATTRIBUTES[i];

    if (attr in props) {
      var cssAttr = attr.replace(/([A-Z])/g, function (g) {
        return "-" + g[0].toLowerCase();
      });
      styles.push(inlineMediaQueryMixin(attr, function (mediaProps) {
        return cssAttr + ": " + mediaProps[attr] + ";";
      })(props));
    }
  };

  for (var i = 0; i < ATTRIBUTES.length; i += 1) {
    _loop(i);
  }

  return styles;
};

var gapCSS = function gapCSS(props) {
  return props.gap ? css(["gap:", ";"], spaceMixin(props.gap)(props)) : "";
};
/** @class FlexMixin */

/** @method */


export var FlexMixin = function FlexMixin(props) {
  return [flexCSS(props), inlineMediaQueryMixin("gap", gapCSS)(props), mediaQueryMixin(function (mediaProps) {
    return flexCSS(mediaProps);
  }), spacingMixin(props)];
};